<app-portal-header *ngIf="screenWidth >= 1024"></app-portal-header>
<app-portal-header-mobile *ngIf="screenWidth < 1024" (onMenuChange)="onMenuChange()"></app-portal-header-mobile>
<app-portal-menu-mobile *ngIf="screenWidth < 1024 && isOpenMenu" (onMenuChange)="onMenuChange()"></app-portal-menu-mobile>
<div class="site-layout portal-placeholder">
  <router-outlet></router-outlet>  
</div>
<app-portal-footer></app-portal-footer>
<!-- <app-portal-footer-pages-mobile *ngIf="screenWidth <= 768"></app-portal-footer-pages-mobile> -->
